const license = {
    not_installed: 'No license is installed on this instance.',
    invalid_key: 'The license key is invalid or has been tampered with.',
    expired_key: 'The license key has expired. Get a fresh key and install it again.',
};
export default Object.freeze(license);
